import { AnyAction } from '@reduxjs/toolkit';
import { FetchUsersRoutine } from '../redux-routines';
import { TUsersListState } from '../interfaces';

const initialState: TUsersListState = {
  isFetching: false,
  data: [],
  error: null,
};

export const usersListReducer = (
  state: TUsersListState = initialState,
  action: AnyAction,
): TUsersListState => {
  switch (action.type) {
    case FetchUsersRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null,
      };
    case FetchUsersRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case FetchUsersRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
